import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

const RefreshLoading = () => (
  <Backdrop
    sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.modal + 1 })}
    open={true}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default RefreshLoading;
